export default {
	er_cover_default_title: 'Revisión de rendimiento',
	er_page_success_metrics: 'Qué cambió este mes',
	er_page_success_metrics_range: 'Qué cambió en este periodo',
	er_page_success_metrics_week: 'Qué cambió esta semana',
	er_page_comparison: 'Resumen comparativo',
	er_page_period_summary: 'Resumen del mes',
	er_page_period_summary_range: 'Resumen del periodo',
	er_page_period_summary_week: 'Resumen de la semana',
	er_page_each_month: 'Cada mes',
	er_page_rooms: 'Salas',
	er_rooms_note: 'Cada sala en {month}, la mejor puntuación primero.',
	er_page_shift_comparison: 'Comparación por turno',
	er_page_shift_summary: 'Por turno',
	er_page_response_time: 'Tiempo medio de respuesta (min)',
	er_page_avg_score: 'Puntuación de experiencia',
	er_page_complaints_vs_visits: 'Quejas vs visitas',
	er_page_performance_trends: 'Tendencias de rendimiento',
	er_page_complaint_drivers: 'Factores de queja',

	er_board_working: 'Mejoró respecto a {month}',
	er_board_attention: 'Requiere atención respecto a {month}',
	er_board_empty: 'No hay cambios relevantes este mes.',
	er_board_empty_range: 'No hay cambios relevantes en este periodo.',
	er_board_empty_week: 'No hay cambios relevantes esta semana.',
	er_findings_intro: 'Comparado con {month}. Solo se muestran cambios relevantes.',
	er_verdict_improved: 'Mejoró',
	er_verdict_watch: 'Requiere atención',

	er_col_metric: 'Métrica',
	er_col_avg: 'Media YTD',
	er_col_lifetime_avg: 'Media desde el inicio',
	er_comparison_note: 'La media YTD es el valor de enero a {month}.',
	er_lifetime_note: 'La media desde el inicio es el promedio mensual desde el primer día con datos hasta {month}.',
	er_comparison_note_week: 'La semana del informe se compara con la semana anterior seleccionada.',
	er_period_only_note: 'Las cifras corresponden solo a {month}.',
	er_each_month_note: 'Cada mes del periodo seleccionado. Un mes sin datos queda en blanco.',
	er_col_inc_dec: 'Var.',
	er_col_complaint: 'Queja',
	er_col_qty: 'Cant.',
	er_total: 'Total',

	er_metric_avg_score: 'Puntuación de experiencia',
	er_metric_avg_response_time: 'Tiempo medio de respuesta',
	er_metric_cleaner_arrivals: 'Llegadas de limpieza',
	er_metric_supervisor_inspections: 'Inspecciones de supervisor',
	er_metric_complaints_vs_visits_pct: 'Quejas frente a visitas (%)',
	er_metric_complaints: 'Quejas',
	er_metric_customer_visits: 'Visitas',
	er_metric_expired_slas: 'SLAs vencidos',
	er_unit_min: 'min',
	er_stat_expected_sla: 'SLA esperado',
	er_stat_vs_minutes: 'frente a {value} en {month}',
	er_stat_vs_count: 'frente a {value} en {month}',
	er_label_complaints: 'Quejas',
	er_label_visits: 'Visitas',
	er_label_complaints_per_visits: 'Quejas / visitas',
	er_chart_ratio: 'Ratio de quejas por visita',
	er_chart_ytd_window: 'De enero a {month}.',
	er_cv_formula: 'Quejas divididas por visitas al baño, en porcentaje: ({complaints} ÷ {visits}) × 100 = {ratio}% en {month}.',
	er_export_kpis_title: 'Qué incluye el informe',
	er_export_kpis_desc: 'Todo esto va en el informe. Desactive uno para dejarlo fuera.',
	er_export_select_all: 'Seleccionar todo',
	er_export_clear_all: 'Borrar todo',
	er_export_summary: '{report} vs {compare}',
	er_export_period_title: 'Periodo del informe',
	er_export_grain: 'Por',
	er_export_grain_month: 'Mes',
	er_export_grain_week: 'Semana',
	er_export_week_starts: 'La semana empieza el',
	er_export_week_starts_sunday: 'domingo',
	er_export_week_starts_monday: 'lunes',
	er_export_report_month: 'Mes del informe',
	er_export_from_month: 'Desde',
	er_export_to_month: 'Hasta',
	er_export_period_note_range: 'El informe suma cada mes desde el inicio hasta el final. Con la comparación activa, usa el periodo anterior de la misma duración. Las cifras del año hasta la fecha siguen yendo de enero al mes final.',
	er_export_summary_range: '{from} – {to}',
	er_export_summary_range_vs: '{from} – {to} vs {compare}',
	er_export_compare_range_note: 'El periodo anterior de la misma duración.',
	er_export_report_week: 'Semana del informe',
	er_export_compare_month: 'Comparar con',
	er_export_shift: 'Turno',
	er_export_shift_all: 'Todos los turnos',
	er_export_no_shifts: 'Este sitio no tiene turnos activos.',
	er_export_render_failed: 'No se pudo generar el informe correctamente, por lo que no se descargó. Actualice la página e inténtelo de nuevo.',
	er_export_comparison: 'Comparación',
	er_export_include_previous: 'Incluir el periodo anterior',
	er_export_comparison_on: 'Activada',
	er_export_comparison_off: 'Desactivada',
	er_export_no_previous_data: 'No hay datos anteriores a este periodo, así que no hay nada con qué comparar.',
	er_export_compare_previous: 'Mes anterior',
	er_export_compare_previous_week: 'Semana anterior',
	er_export_compare_last_year: 'Mismo mes del año pasado',
	er_export_no_periods: 'Este sitio necesita al menos un mes de datos para exportar un informe.',
	er_export_no_periods_week: 'Este sitio necesita al menos una semana de datos para exportar un informe.',
	er_export_period_note: 'Solo se listan los meses con datos. Las cifras del año hasta la fecha siempre van de enero al mes del informe.',
	er_export_period_note_week: 'Solo se listan las semanas con datos. La comparación es siempre con una semana anterior.',
	er_export_period_note_single_week: 'Solo se listan las semanas con datos.',

	er_find_response_time_title: 'Tiempo medio de respuesta',
	er_find_response_time_change:
		'Cambió de {previous} a {current} minutos ({change}).',
	er_find_avg_score_title: 'Puntuación de experiencia',
	er_find_score_eased: 'Bajó de {previous} a {current}.',
	er_find_score_improved: 'Subió de {previous} a {current}.',
	er_find_score_ytd_inline: 'Coincide con el promedio del año ({ytd}).',
	er_find_score_ytd_inline_range: 'Igual a la media de enero a {endMonth} ({ytd}).',
	er_find_score_ytd_against: 'Promedio del año: {ytd}.',
	er_find_score_ytd_against_range: 'Media de enero a {endMonth}: {ytd}.',
	er_find_complaints_ratio_title: 'Ratio de quejas por visita',
	er_find_complaints_ratio_improved:
		'Mejoró de {previous} a {current}.',
	er_find_complaints_ratio_rose:
		'Cambió de {previous} a {current}.',

	er_nar_cv_year_improved:
		'Las quejas de clientes en relación con las visitas al baño mejoraron de {from} a {to} a lo largo del año.',
	er_nar_cv_year_rose:
		'Las quejas de clientes en relación con las visitas al baño aumentaron de {from} a {to} a lo largo del año.',
	er_nar_cv_moved: 'Las quejas de clientes en relación con las visitas al baño pasaron de {previous} a {current}.',
	er_nar_cv_current: 'Las quejas de clientes en relación con las visitas al baño se sitúan en {current}.',
	er_nar_types_total: 'Total de quejas {total}.',
	er_nar_types_1: 'Queja principal: {a} ({ap}%).',
	er_nar_types_2: 'Queja principal: {a} ({ap}%), seguida de {b} ({bp}%).',
	er_nar_types_3: 'Queja principal: {a} ({ap}%), seguida de {b} ({bp}%) y {c} ({cp}%).',
	er_find_rooms_slowest: 'Salas con el tiempo de respuesta más largo este mes: {rooms}.',
	er_find_rooms_slowest_range: 'Salas con el tiempo de respuesta más largo en este periodo: {rooms}.',
	er_find_rooms_slowest_week: 'Salas con el tiempo de respuesta más largo esta semana: {rooms}.',
	er_find_rooms_lowest_score: 'Salas con peor puntuación este mes: {rooms}.',
	er_find_rooms_lowest_score_range: 'Salas con la puntuación más baja en este periodo: {rooms}.',
	er_find_rooms_lowest_score_week: 'Salas con peor puntuación esta semana: {rooms}.',

	er_find_so_what_ratio: 'La mayor parte del cambio vino de {rooms}.',
	er_find_so_what_type: 'Queja principal: {name} ({percent}%).',
	er_hot_slowest: 'Salas con el tiempo de respuesta más largo',
	er_hot_expired_slas: 'Salas que superaron el SLA',
	er_hot_ratio: 'Salas con el mayor cambio en la tasa de quejas',
	er_hot_top_type: 'Salas con más quejas de "{name}"',
	er_hot_col_room: 'Sala',
	er_col_response: 'Respuesta',
	er_col_cleaners: 'Limpiadores',
	er_col_score: 'Puntuación',
	er_chart_sla: 'SLA',
	er_hot_col_ratio: 'Ratio',
	er_hot_col_change: 'Cambio',
	er_hot_col_count: 'Cant.',
	er_hot_empty: 'No hay destacados a nivel de sala este mes.',
	er_hot_empty_range: 'No hay destacados a nivel de sala en este periodo.',
	er_hot_empty_week: 'No hay destacados a nivel de sala esta semana.',
	er_cover_highlights: 'Este mes',
	er_cover_highlights_range: 'Este periodo',
	er_cover_highlights_week: 'Esta semana',
	er_cover_score_rose: 'La puntuación de experiencia subió.',
	er_cover_score_eased: 'La puntuación de experiencia bajó.',
	er_cover_response_improved: 'El tiempo de respuesta mejoró.',
	er_cover_response_slowed: 'El tiempo de respuesta se alargó.',
	er_cover_ratio_fell: 'Las quejas frente a visitas bajaron.',
	er_cover_ratio_rose: 'Las quejas frente a visitas subieron.',
	er_export_pdf: 'PDF del panel',
	er_export_executive: 'Informe ejecutivo',
	'executive-report': 'Informe ejecutivo',
	er_export_csv: 'CSV',
	er_export_status_title: 'Creando el informe',
	er_export_status_fetch: 'Cargando las cifras',
	er_export_status_layout: 'Preparando las páginas',
	er_export_status_page: 'Página {page} de {total}',
	er_footer_copyright: 'Este informe se generó a través del sistema BuzzzTech.',
	er_contact_line: '¿Tiene preguntas o quiere explorar los datos en más detalle? Comuníquese con el equipo de Customer Success de BuzzzTech en {email} o {phone}.',
};
